import { getDataFromSSR } from "@/handlers/client/commonClient";
import { parseMatchData } from "@/utils/ipl";
import { logger } from "@/utils/logging/log-util";
// import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import SVG from "react-inlinesvg";

const SeriesMatchCarousel = ({ matchData = null, isTestSeries = false }) => {
  const scrollable = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [allowRight, setAllowRight] = useState(true);
  const [allowLeft, setAllowLeft] = useState(false);
  const [matches, setMatches] = useState(matchData);

  const handleScrollLeft = () => {
    const scrollBy = scrollable.current.scrollWidth / matches?.length + 1.5;
    const newPosition = Math.max(scrollPosition - scrollBy, 0); // Limit to min 0
    scrollable.current.scrollLeft = newPosition;
    setScrollPosition(newPosition);
  };

  const handleScrollRight = () => {
    const scrollBy = scrollable.current.scrollWidth / matches?.length + 1.5;
    const contentWidth = scrollable.current.scrollWidth;
    const containerWidth = scrollable.current.clientWidth;
    const maxScroll = contentWidth - containerWidth;
    const newPosition = Math.min(scrollPosition + scrollBy, maxScroll); // Limit to max scroll

    scrollable.current.scrollLeft = newPosition;
    setScrollPosition(newPosition);
  };

  const checkScroll = () => {
    const contentWidth = scrollable.current.scrollWidth;
    const containerWidth = scrollable.current.clientWidth;
    const isAtEnd =
      scrollable.current.scrollLeft === contentWidth - containerWidth;
    const isAtStart = scrollable.current.scrollLeft === 0;
    setAllowRight(!isAtEnd);
    setAllowLeft(!isAtStart);
  };
  useEffect(() => {
    scrollable?.current?.addEventListener("scroll", checkScroll);
    return () => {
      scrollable?.current?.removeEventListener("scroll", checkScroll);
    };
  }, [scrollable]);

  useEffect(() => {
    let isMounted = true;
    const testSeriesId = 8159;
    const asiacupId = 13274; //12551; // 13274;  asia cup
    async function getMatches() {
      try {
        const timeStamp = Date.now();
        // const livematches = await getDataFromSSR(
        //   `/api/getLiveMatches?seriesId=${isTestSeries ? testSeriesId : asiacupId
        //   }&time=${timeStamp}`
        // );
        const livematches = null; //disable getLiveMatches

        if (livematches && livematches.data?.data?.length > 0) {
          setMatches((prevMatches) => {
            const updated = [...prevMatches];

            for (const rawMatch of livematches.data.data) {
              const matchStats = parseMatchData(rawMatch);

              const idx = updated.findIndex((m) => m.id === rawMatch.match_Id);

              if (idx > -1) {
                updated[idx] = matchStats; // update existing
              } else {
                updated.unshift(matchStats); // prepend new
              }
            }
            return updated;
          });
          window.allowLivePolling = true;
        } else {
          window.allowLivePolling = false;
        }
      } catch (err) {
        logger.error(err);
      }
    }

    getMatches(); // fetch initially

    const interval = setInterval(() => {
      if (isMounted && window.allowLivePolling) getMatches();
    }, 10000);

    return () => {
      clearInterval(interval);
      isMounted = false;
    };
  }, []); // 🚫 don't depend on matches


  return (
    <div className="w-full max-h-fit my-8">
      <div className="flex items-center justify-between">
        <h2 className="pl-1 text-lg font-semibold">Matches</h2>
        <a
          className="text-sm"
          href={
            isTestSeries
              ? "/sports/cricket/india-tour-of-england-2025/schedule"
              : "/sports/asia-cup-2025/match-schedule-fixtures-and-results"
          }
        >
          <span className="flex items-center">
            See All
            <SVG
              className="w-3 h-3 inline ml-1 -mb-[1.5px]"
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/right.svg"
            />
          </span>
        </a>
      </div>
      {!matches && (
        <div className="w-full h-40 bg-gray-300 animate-pulse rounded-md" />
      )}
      {matches && (
        <div className="relative w-full p-1">
          {/* scroll btns */}
          {allowLeft && (
            <div className="hidden md:block absolute top-[40%] -left-3 font-semibold text-xl h-full w-16">
              <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/leftArrow.svg"
                className={`w-6 h-6 p-1 text-primary border border-gray-300 cursor-pointer rounded-full bg-white`}
                onClick={handleScrollLeft}
              />
            </div>
          )}
          {allowRight && (
            <div className="hidden md:block absolute top-[40%] -right-14 font-semibold text-xl h-full w-16">
              <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/rightArrow2.svg"
                className={`w-6 h-6 p-1 text-primary border border-gray-300 cursor-pointer rounded-full bg-white`}
                onClick={handleScrollRight}
              />
            </div>
          )}

          <div
            ref={scrollable}
            className="w-full flex items-center gap-2 overflow-x-auto"
            style={{ scrollbarWidth: "none", scrollBehavior: "smooth" }}
          >
            {/* match card  */}
            {matches
              ?.filter((item) => item.match_date !== "Invalid Date")
              ?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="min-w-[90%] md:min-w-[33%] gap-0 bg-white rounded-lg border border-gray-300 py-2"
                  >
                    <a
                      href={
                        item?.url ||
                        "/sports/cricket/india-tour-of-england-2025"
                      }
                    >
                      <div className="w-full px-2 border-b border-gray-300 flex items-center justify-between">
                        <span className="text-[#000000CC] flex items-center gap-1 text-xs mb-1">
                          <span className="">
                            {isTestSeries
                              ? "India vs England"
                              : item?.teamA_name?.toUpperCase() +
                              " vs " +
                              item?.teamB_name?.toUpperCase()}
                          </span>
                          <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                          {item?.match_no}
                        </span>
                        <span className="flex items-center gap-1 text-sm mb-1">
                          {item.status}
                          {item?.status == "LIVE" && (
                            <img
                              height={24}
                              width={24}
                              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveGif.gif"
                              alt="live icon"
                            />
                          )}
                        </span>
                      </div>
                      <div className="p-2">
                        <span className="flex items-center gap-2 mb-2">
                          <img
                            width={24}
                            height={24}
                            src={
                              isTestSeries
                                ? item.teamA_name !== "tbc"
                                  ? item.altLogoA || "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/englandLogo.png"
                                  : item.teama_logo
                                : item?.teama_logo
                            }
                            alt="teamA logo"
                          />

                          <span className="text-xs font-[600]">
                            {item?.teamA_name?.toUpperCase()}
                          </span>
                          {item?.winning_team == "A" && (
                            <img
                              src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                              width={20}
                              height={20}
                              alt="trophy gif"
                            />
                          )}
                          {item?.status == "UPCOMING" ? (
                            <span className={`text-sm ml-auto `}>
                              {item.match_date}
                            </span>
                          ) : (
                            <span
                              className={`text-sm ml-auto ${item?.batting_team == "A" ||
                                item?.winning_team == "A"
                                ? "font-semibold"
                                : "mr-1"
                                }`}
                            >
                              {item.teamA_score || "Yet to bat"}{" "}
                              {item.teamA_overs
                                ? "(" + item.teamA_overs + ")"
                                : ""}
                              {item?.batting_team == "A" && (
                                <span className="text-primary text-md font-semibold">
                                  *
                                </span>
                              )}
                            </span>
                          )}
                        </span>
                        <span className="flex items-center gap-2 mb-1">
                          <img
                            width={24}
                            height={24}
                            src={
                              isTestSeries
                                ? item.teamB_name != "tbc"
                                  ? item.altLogoB || "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/indiaLogo.png"
                                  : item.teamb_logo
                                : item?.teamb_logo
                            }
                            alt="teamA logo"
                          // className="rounded-full"
                          />
                          <span className="text-xs font-[600]">
                            {item?.teamB_name?.toUpperCase()}
                          </span>
                          {item?.winning_team == "B" && (
                            <img
                              src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                              width={20}
                              height={20}
                              alt="trophy gif"
                            />
                          )}
                          {item?.status == "UPCOMING" ? (
                            <span className={`text-sm ml-auto `}>
                              {item?.match_time_gmt || item.match_time}
                            </span>
                          ) : (
                            <span
                              className={`text-sm ml-auto ${item?.batting_team == "B" ||
                                item?.winning_team == "B"
                                ? "font-semibold"
                                : "mr-1"
                                }`}
                            >
                              {item.teamB_score || "Yet to bat"}{" "}
                              {item.teamB_overs
                                ? "(" + item.teamB_overs + ")"
                                : ""}
                              {item?.batting_team == "B" && (
                                <span className="text-primary text-md font-semibold">
                                  *
                                </span>
                              )}
                            </span>
                          )}
                        </span>
                      </div>
                      <div className="bg-gray-200 w-full p-2 text-center text-xs font-semibold">
                        <span>{item?.equation}</span>
                      </div>
                    </a>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default SeriesMatchCarousel;
